import template from './invoice-create-wizard.html';
import controller from './invoice-create-wizard.controller';

let invoiceCreateWizardComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default invoiceCreateWizardComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create-wizard/invoice-create-wizard.component.js